<template>
  <div class="report">
    <h2>报告 <!--<a class="save" @click="saveAsImage">保存为图片</a>--></h2>
    <div ref="wrapper">
      <a-table
        :columns="columns"
        :dataSource="transformedDataSource"
        bordered
        :pagination="false"
      >
        <div slot="model" slot-scope="model,r" class="img">
          <div class="imgWrapper">
            <img :src="model" />
            <h4>{{r.modelKey || ''}}</h4>
          </div>
        </div>

        <div slot="projection" slot-scope="projection" class="img">
          <img :src="projection" />
        </div>

        <div slot="vectoringPrinciple" slot-scope="vectoringPrinciple" style="text-align:left;margin:0 10px">
          <div v-for="line in vectoringPrinciple">{{line}}</div>
        </div>

        <div slot="crystalGeometryConstant" slot-scope="crystalGeometryConstant" style="text-align:left;margin:0 10px">
          <div v-for="line in crystalGeometryConstant">{{line}}</div>
        </div>
        
        <span slot="opt" slot-scope="text, record">
          <a-button icon="delete" size="small" type="danger" @click="deleteHandler(record)" />
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { CRYSTAL_CLUSTERS, CRYSTAL_SYS, POINT_TYPES } from '@/constants/cvts'
import eol from 'eol'

const getCvtLabel = (cvt, key) => {
  const m = cvt.find(c => c.key === key)
  return m ? m.label : ''
}

const columns = [{
  title: '模型',
  dataIndex: 'model',
  key: 'model',
  width: '210px',
  scopedSlots: { customRender: 'model' }
}, {
  title: '投影图',
  dataIndex: 'projection',
  key: 'projection',
  width: '210px',
  scopedSlots: { customRender: 'projection' }
}, {
  title: '对称型',
  dataIndex: 'symTyp',
  key: 'symTyp',
  children: [{
    title: '一般符号',
    dataIndex: 'normalSymbol',
    key: 'normalSymbol',
    width: '120px'
  }, {
    title: '国际符号',
    dataIndex: 'nationalSymbol',
    key: 'nationalSymbol',
    width: '120px'
  }]
}, {
  title: '对称分类',
  dataIndex: 'symCategory',
  key: 'symCategory',
  children: [{
    title: '晶族',
    dataIndex: 'crystalCluster',
    key: 'crystalCluster',
    width: '80px'
  }, {
    title: '晶系',
    dataIndex: 'crystalSys',
    key: 'crystalSys',
    width: '80px'
  }]
}, {
  title: '晶体符号',
  dataIndex: 'crystalVectoring',
  key: 'crystalVectoring',
  children: [{
    title: '晶面符号',
    dataIndex: 'vectoringPrinciple',
    key: 'vectoringPrinciple',
    scopedSlots: { customRender: 'vectoringPrinciple' }
  }, {
    title: '主要晶棱符号',
    dataIndex: 'crystalGeometryConstant',
    key: 'crystalGeometryConstant',
    scopedSlots: { customRender: 'crystalGeometryConstant' }
  }]
}, {
  title: '操作',
  dataIndex: 'opt',
  key: 'opt',
  width: '50px',
  scopedSlots: { customRender: 'opt' }
}]

export default {

  props: {
    dataSource: {
      type: Array,
      default: () => [] // [{ model, projection }]
    }
  },

  data () {
    return {
      columns
    }
  },

  computed: {
    transformedDataSource () {
      return this.dataSource.map(d => ({
        ...d,
        nationalSymbol: getCvtLabel(POINT_TYPES, d.nationalSymbol),
        crystalCluster: getCvtLabel(CRYSTAL_CLUSTERS, d.crystalCluster),
        crystalSys: getCvtLabel(CRYSTAL_SYS, d.crystalSys),
        vectoringPrinciple: eol.split(d.vectoringPrinciple),
        crystalGeometryConstant: eol.split(d.crystalGeometryConstant)
      }))
    }
  },

  methods: {
    deleteHandler (record) {
      this.$emit('delete', record)
    },
    saveAsImage () {
      html2canvas(this.$refs.wrapper).then(canvas => {
        // window.location.href = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
        const w = window.open()
        w.document.write(`
          <p>
          右键保存图片
          </p>
          <img src="${canvas.toDataURL('image/png')}" />
        `)
      })
    }
  }
}
</script>

<style scoped>
.report {
  margin-top: 20px;
  overflow-x: auto;
}
.save {
  font-size: 12px;
}
.img {
  position: relative;
  text-align: center;
}
.img .imgWrapper {
  position: relative;
  width: 200px;
  display: inline-block;
}
.img img {
  width: 200px;
  height: 200px;
  background: #e8e8e8;
}
.img h4 {
  position: absolute;
  top: 6px;
  left: 10px;
  width: 200px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/ReportTable.vue